export default function BasicContentLoader() {
  return (
    <div className="basic-content-loader">
      <div className="basic-loader-bar basic-full-bar"></div>
      <div className="basic-loader-bar basic-medium-bar"></div>
      <div className="basic-loader-bar basic-large-bar"></div>
      <div className="basic-loader-bar basic-small-bar"></div>
    </div>
  );
}
